/**
 * キャンペーン専用LP管理
 *
 * 新しいキャンペーンの追加方法:
 * 1. CAMPAIGNS 配列にエントリを追加（slug, displayName, etc.）
 * 2. デフォルトの内容で良ければ何もしなくてOK（MonitorCampaign が自動表示）
 * 3. 個別の文言や特典を変えたい場合は overrides フィールドを設定
 *
 * 検出順:
 *   1) サブドメイン: {slug}.shiftmagic.jp
 *   2) パス: /campaigns/{slug}
 *   3) クエリ: ?lp={slug}
 *   4) 旧パス互換: /{slug}  (maruhei のみ歴史的経緯で対応)
 */

export const CAMPAIGNS = [
  {
    slug: "maruhei",
    displayName: "丸平 様 限定",
    badge: "先着 30 社 限定モニター募集中",
    headline: ["いま申し込むと、", "最大 4ヶ月もお得に始められます。"],
    deadlineLabel: "2026年6月5日",
    legacyPath: "/maruhei", // 後方互換: /maruhei でも到達できる
  },
  // 追加例:
  // {
  //   slug: "referral",
  //   displayName: "ご紹介者様 限定",
  //   badge: "ご紹介経由 特別キャンペーン",
  //   headline: ["ご紹介ありがとうございます！", "特別価格でご利用いただけます。"],
  //   deadlineLabel: "2026年12月31日",
  // },
];

export const CAMPAIGN_BASE_HOST = "shiftmagic.jp";

function getCampaignBySlug(slug) {
  if (!slug) return null;
  return CAMPAIGNS.find((c) => c.slug === slug) || null;
}

/**
 * 現在のリクエストから該当キャンペーンを判定。
 * 該当しなければ null。
 */
export function detectCampaign() {
  if (typeof window === "undefined") return null;
  const host = window.location.hostname;
  const path = window.location.pathname;
  const params = new URLSearchParams(window.location.search);

  // 1) サブドメイン: {slug}.shiftmagic.jp
  const hostParts = host.split(".");
  if (hostParts.length >= 3 && host.endsWith(CAMPAIGN_BASE_HOST)) {
    const sub = hostParts[0];
    const c = getCampaignBySlug(sub);
    if (c) return c;
  }

  // 2) /campaigns/{slug}
  const campMatch = path.match(/^\/campaigns\/([a-z0-9-]+)/i);
  if (campMatch) {
    const c = getCampaignBySlug(campMatch[1].toLowerCase());
    if (c) return c;
  }

  // 3) ?lp={slug}
  const lpParam = params.get("lp");
  if (lpParam) {
    const c = getCampaignBySlug(lpParam.toLowerCase());
    if (c) return c;
  }

  // 4) 旧パス互換 (例: /maruhei)
  for (const c of CAMPAIGNS) {
    if (c.legacyPath && (path === c.legacyPath || path.startsWith(c.legacyPath + "/"))) {
      return c;
    }
  }

  return null;
}

/**
 * 指定キャンペーンの「お申込み先URL」（QRコードに埋め込む等）
 * production: https://{slug}.shiftmagic.jp/
 * その他環境: 現在のオリジン + /campaigns/{slug}
 */
export function campaignLandingUrl(slug) {
  if (typeof window === "undefined") return `https://${slug}.${CAMPAIGN_BASE_HOST}/`;
  const host = window.location.hostname;
  // 本番ドメインのときだけサブドメインURLを返す
  if (host === CAMPAIGN_BASE_HOST || host === "www." + CAMPAIGN_BASE_HOST || host.endsWith("." + CAMPAIGN_BASE_HOST)) {
    return `https://${slug}.${CAMPAIGN_BASE_HOST}/`;
  }
  // プレビュー / ローカル: 同じオリジンのパスへ
  return `${window.location.origin}/campaigns/${slug}`;
}
